import { Controller } from "stimulus"
import select2 from 'select2'

export default class extends Controller {
  connect() {
    $(this.element).select2()
  }
}